import React from 'react';

import CommonImage from '@/components/CommonImage';
import { PRIORITY_TAGS } from '@/features/project-management-tools/constents';

export default function RequestDetailsListView() {
	// Priority dropdown component
	const PriorityDropdown = ({ priority }) => (
		<div className="option">
			<div className="dropdown">
				<button
					aria-expanded="false"
					className="btn btn-default dropdown-toggle"
					data-toggle="dropdown"
					id="menu1"
					type="button"
				>
					<span className={`mr-2 status yellow-1 status-with-border  ${PRIORITY_TAGS[priority]}`}>
						{priority || 'Select priority'}
					</span>
					<CommonImage
						className="arrow-icon"
						src="/icons/down-arrow-gray-dark-01.svg"
						width={20}
						height={20}
					/>
				</button>
				<ul
					aria-labelledby="menu1"
					className="dropdown-menu dropdown-menu-right shadow-lg"
					role="menu"
					x-placement="bottom-end"
				>
					{PRIORITY_TAGS?.map((tag) => (
						<li
							key={tag.constant}
							className="px-4 pb-3 pt-3"
							role="presentation"
							// onClick={() =>
							// 	handleUpdatePriority({
							// 		...project,
							// 		projectPriority: tag.constant
							// 	})
							// }
						>
							<span
								className={`font-weight-normal ${tag.className}`}
								role="menuitem"
								tabIndex={-1}
							>
								{tag.name}
							</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);

	return (
		<>
			<div className="journey-configuration-container px-4 py-2">
				<div className="single-table">
					<p className="semibold-14 text-underline mb-12 cursor-pointer">
						ZALANDO #D23-A0846: SS 26 Men’s collection
					</p>
					<div className="data-table scroll-x-label">
						<div className="request-details-list-table">
							<table className="table with-border request-details-table">
								<thead>
									<tr>
										<th>
											<div className="custom-chekbox">
												<div className="form-group m-0">
													<input
														type="checkbox"
														id="selectAllRequest"
														name="selectAllRequest"
													/>
													<label htmlFor="selectAllRequest" />
												</div>
											</div>
										</th>
										<th>Image</th>
										<th>Ref</th>
										<th className="white-space-nowrap">Style details</th>
										<th>Brand</th>
										<th>Request</th>
										<th className="white-space-nowrap">PO Request & Nov</th>
										<th className="white-space-nowrap">Planned vs Actual</th>
										<th>L/D Status</th>
										<th className="white-space-nowrap">Pending Issue</th>
										<th>Priority</th>
										<th className="white-space-nowrap">Pattern & Cutting complete</th>
										<th>Print</th>
										<th>Embo</th>
										<th>Sewing</th>
										<th>Wash</th>
										<th>QC review</th>
										<th className="white-space-nowrap">TP owner review</th>
										<th>Note</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="checkbox-column">
											<div className="custom-chekbox">
												<div className="form-group m-0">
													<input type="checkbox" id="select_1" name="select_1" />
													<label htmlFor="select_1" />
												</div>
											</div>
										</td>
										<td className="image-column">
											<div className="d-flex align-items-center justify-content-center">
												<img
													src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
													alt=""
													className="cell-img pr-2"
												/>
											</div>
										</td>
										<td className="ref-column">
											<p className="regular-14  gray_dark_02 mb-0">MT23-A1262</p>
										</td>
										<td className="style-details-column">
											<p className="regular-14  gray_dark_02 mb-0">Man-Kr</p>
											<p className="regular-14  gray_dark_02 mb-0">BW(B)01</p>
											<p className="regular-14  gray_dark_02 mb-0">Manna</p>
										</td>
										<td className="brand-column">
											<p className="regular-14  gray_dark_02 mb-0">ZARA</p>
										</td>
										<td className="request-column">
											<p className="mb-0">
												<a
													href="#"
													className="regular-14 text-underline gray_dark_01"
												>
													SG 2G Manna
												</a>
											</p>
											<p className="regular-14 gray_dark_02 mb-0">collection</p>
										</td>
										<td className="po-request-column">
											<p className="regular-14  gray_dark_02 mb-0">
												Send to PC 25-Apr-26. Manna
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Received: 26-Apr-26. Manna
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												GT review: 26-Apr-26. Tushar
											</p>
										</td>
										<td className="planned-vs-actual-column">
											<p className="regular-14  gray_dark_02 mb-0">
												Required: 04-Apr-26
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Planned: 26-Apr-26
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Actual H/D: 26-Apr-26
											</p>
										</td>
										<td className="l-d-status-column">
											<span className="status yellow-1 status-with-border d-inline-block mb-1">
												Send to R&D
											</span>
											<p className="regular-14 gray_dark_02 mb-0">
												12 Apr, 24 (by Hax)
											</p>
										</td>
										<td className="pending-issue-column">
											<p className="regular-14  gray_dark_02 mb-0">4</p>
										</td>
										<td className="priority-column">
											<PriorityDropdown
												priority="High"
												handleUpdatePriority={() => {}}
												project={null}
											/>
										</td>
										<td className="pattern-cutting-complete-column">
											<p className="regular-14  gray_dark_02 mb-0">Garment GSM: 180</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Cutting: 26-Apr-26. Tushar
											</p>
										</td>
										<td className="print-column">
											<p className="regular-14  gray_dark_02 mb-0">-Screen print, P3</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Rec print: 26-Apr-26
											</p>
										</td>
										<td className="embo-column">
											<p className="regular-14  gray_dark_02 mb-0">Flat embo, Embo 2</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Rec Embo: 26-Apr-26
											</p>
										</td>
										<td className="sewing-column">
											<p className="regular-14  gray_dark_02 mb-0">
												Sewing completed: 26-Apr-26
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												By B. Chyr. Kadir, 2 pcs
											</p>
										</td>
										<td className="wash-column">
											<p className="regular-14  gray_dark_02 mb-0">-Acid wash</p>
											<p className="regular-14  gray_dark_02 mb-0">-L-125L, Wh(02)</p>
											<p className="regular-14  gray_dark_02 mb-0">
												Rec wash: 26-Apr-26
											</p>
										</td>
										<td className="qc-review-column">
											<p className="regular-14  gray_dark_02 mb-0">
												Finishing: 26-Apr-26. Manna
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												QC review: 26-Apr-26. Tushar
											</p>
										</td>
										<td className="tp-owner-review-column">
											<p className="regular-14  gray_dark_02 mb-0">
												- Reviewed: 26-Apr-26. Manna
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												- Yes, it achieved
											</p>
											<p className="regular-14  gray_dark_02 mb-0">
												I&apos;m very satisfied - meets expectations
											</p>
										</td>
										<td className="note-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
									</tr>
									<tr>
										<td className="checkbox-column">
											<div className="custom-chekbox">
												<div className="form-group m-0">
													<input type="checkbox" id="select_2" name="select_2" />
													<label htmlFor="select_2" />
												</div>
											</div>
										</td>
										<td />
										<td className="ref-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="style-details-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="brand-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="request-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="po-request-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="planned-vs-actual-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="l-d-status-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="pending-issue-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td>
											<p className="regular-14  gray_dark_02 mb-0">4</p>
										</td>
										<td className="priority-column">
											<span className="status yellow-1 status-with-border">High</span>
										</td>
										<td className="pattern-cutting-complete-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="print-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="embo-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="sewing-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="wash-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="qc-review-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
										<td className="tp-owner-review-column">
											<p className="regular-14 gray_dark_02 mb-0">-</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div>
					<div className="send-to-pd-journey-table mt-4">
						<div className="single-table">
							<p className="semibold-14 text-underline mb-12 cursor-pointer">
								Send to PD journey table
							</p>
							<div className="data-table scroll-x-label">
								<div className="send-to-pd-journey-table-wrapper">
									<table className="table with-border send-to-pd-table">
										<thead>
											<tr>
												<th>
													<div className="custom-chekbox">
														<div className="form-group m-0">
															<input
																type="checkbox"
																id="selectAllSendToPd"
																name="selectAllSendToPd"
															/>
															<label htmlFor="selectAllSendToPd" />
														</div>
													</div>
												</th>
												<th>Image</th>
												<th className="white-space-nowrap">Style details</th>
												<th className="white-space-nowrap">Body fabric</th>
												<th className="white-space-nowrap">Print, Embo</th>
												<th>Wash</th>
												<th>Qty</th>
												<th className="white-space-nowrap">Buyer target price</th>
												<th className="white-space-nowrap">Production price</th>
												<th className="white-space-nowrap">Offer price</th>
												<th>Remarks</th>
												<th className="white-space-nowrap">Last status</th>
												<th>Request</th>
												<th className="white-space-nowrap">
													Required &amp; complete
												</th>
												<th>Conversation</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="checkbox-column">
													<div className="custom-chekbox">
														<div className="form-group m-0">
															<input
																type="checkbox"
																id="send_to_pd_1"
																name="send_to_pd_1"
															/>
															<label htmlFor="send_to_pd_1" />
														</div>
													</div>
												</td>
												<td className="image-column" rowSpan={3}>
													<div className="d-flex align-items-center justify-content-center">
														<img
															src={`${process.env.PUBLIC_URL}/images/fabric-default.png`}
															alt=""
															className="cell-img pr-2"
														/>
													</div>
												</td>
												<td className="style-details-column" rowSpan={3}>
													<p className="semibold-14 gray_dark_01 mb-4">
														MT22-A1280
													</p>
													<p className="regular-14 gray_dark_02 mb-0">Men-Knit</p>
													<p className="regular-14 gray_dark_02 mb-0">Basic tee</p>
												</td>
												<td className="body-fabric-column" rowSpan={3}>
													<p className="regular-14 gray_dark_02 mb-0">
														-Fleece, 100 Cotton, 20s polyester
													</p>
												</td>
												<td className="print-embo-column" rowSpan={3}>
													<p className="regular-14 gray_dark_02 mb-0">
														Print: Screen print, HD print
													</p>
													<p className="regular-14 gray_dark_02 mb-0">
														Embo: Flat embroidery
													</p>
												</td>
												<td className="wash-column" rowSpan={3}>
													<p className="regular-14 gray_dark_02 mb-0">Acid wash</p>
												</td>
												<td className="qty-column">
													<p className="regular-14 gray_dark_02 mb-0">1000</p>
												</td>
												<td className="buyer-target-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="production-price-column">
													<p className="regular-14 gray_dark_02 mb-0">
														<span className="gray_dark_02 add-price">
															Add price
														</span>
													</p>
												</td>
												<td className="offer-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="remarks-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="last-status-column" rowSpan={3}>
													<span className="status yellow-1 status-with-border d-inline-block mb-1">
														Send for costing
													</span>
													<p className="regular-12 gray_dark_02 mb-0">
														12 Apr, 24 by Hasib
													</p>
												</td>
												<td className="request-column" rowSpan={3}>
													<p className="regular-12 gray_dark_02 mb-0">
														Requested: 25-Apr, Mamu
													</p>
													<p className="regular-12 gray_dark_02 mb-0">
														Rcv: 23-Apr, Hasibul
													</p>
												</td>
												<td className="required-complete-column" rowSpan={3}>
													<p className="regular-12 gray_dark_02 mb-0">
														Required: 25-Apr
													</p>
													<p className="regular-12 gray_dark_02 mb-0">
														Completed: 23-Apr, Hasibul
													</p>
													<p className="regular-12 gray_dark_02 mb-0">
														Send to buyer: 23-Apr
													</p>
												</td>
												<td className="conversation-column" rowSpan={3}>
													<div className="conversation-btn">
														<button className="button text">
															<CommonImage
																className="cursor-pointer"
																src="icons/comments-gray.svg"
																width={24}
																height={24}
															/>
														</button>
													</div>
												</td>
											</tr>
											<tr>
												<td className="checkbox-column">
													<div className="custom-chekbox">
														<div className="form-group m-0">
															<input
																type="checkbox"
																id="send_to_pd_2"
																name="send_to_pd_2"
															/>
															<label htmlFor="send_to_pd_2" />
														</div>
													</div>
												</td>
												<td className="qty-column">
													<p className="regular-14 gray_dark_02 mb-0">3000</p>
												</td>
												<td className="buyer-target-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="production-price-column">
													<p className="regular-14 gray_dark_02 mb-0">
														<span className="gray_dark_02 add-price">
															Add price
														</span>
													</p>
												</td>
												<td className="offer-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="remarks-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
											</tr>
											<tr>
												<td className="checkbox-column">
													<div className="custom-chekbox">
														<div className="form-group m-0">
															<input
																type="checkbox"
																id="send_to_pd_3"
																name="send_to_pd_3"
															/>
															<label htmlFor="send_to_pd_3" />
														</div>
													</div>
												</td>
												<td className="qty-column">
													<p className="regular-14 gray_dark_02 mb-0">5000</p>
												</td>
												<td className="buyer-target-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="production-price-column">
													<p className="regular-14 gray_dark_02 mb-0">
														<span className="gray_dark_02 add-price">
															Add price
														</span>
													</p>
												</td>
												<td className="offer-price-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
												<td className="remarks-column">
													<p className="regular-14 gray_dark_02 mb-0">-</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
